<template>
  <div class="text-center">
    <p v-if="showUbication">
      <span class="font-weight-bold">{{ $t("equipmentList.plant") }}:</span>
      {{ equipmentProfile.plant.name }}<br />
      <span class="font-weight-bold">{{ $t("equipmentList.area") }}:</span>
      {{ equipmentProfile.area.name }}<br />
      <span class="font-weight-bold">{{ $t("equipmentList.unit") }}:</span>
      {{ equipmentProfile.unit.name }}<br />
    </p>
    <v-dialog v-model="dialog" width="500">
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="primary mt-2" dark v-bind="attrs" v-on="on">
          {{ $t("newEquipment.location") }}
        </v-btn>
      </template>

      <v-card>
        <v-stepper v-model="e6" vertical>
          <v-stepper-step :editable="e6 > 1" :complete="e6 > 1" step="1">
            {{ $t("newEquipment.selectPlant") }}
          </v-stepper-step>

          <v-stepper-content step="1">
            <v-select
              filled
              return-object=""
              v-model="equipmentProfile.plant"
              :label="$t('newEquipment.plant')"
              :items="plants"
              item-text="name"
              item-value="name"
              @input="e6 = 2"
            ></v-select>
          </v-stepper-content>

          <v-stepper-step :editable="e6 > 2" :complete="e6 > 2" step="2">{{
            $t("newEquipment.selectArea")
          }}</v-stepper-step>

          <v-stepper-content step="2">
            <v-select
              filled
              return-object=""
              v-model="equipmentProfile.area"
              :label="$t('newEquipment.area')"
              :items="areas"
              item-text="name"
              item-value="name"
              @input="e6 = 3"
            ></v-select>
          </v-stepper-content>

          <v-stepper-step step="3">{{
            $t("newEquipment.selectUnit")
          }}</v-stepper-step>
          <v-stepper-content step="3">
            <v-select
              filled
              return-object=""
              v-model="equipmentProfile.unit"
              :label="$t('newEquipment.area')"
              :items="units"
              item-text="name"
              item-value="name"
              @input="setUbication"
            ></v-select>
          </v-stepper-content>
        </v-stepper>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    showUbication() {
      return this.equipmentProfile?.unit?.name ? true : false;
    },
    ...mapState("settings", ["plants"]),
    areas() {
      return this.equipmentProfile?.plant?.areas;
    },
    units() {
      return this.equipmentProfile?.area?.units;
    }
  },
  methods: {
    setUbication() {
      let payload = {
        plant: this.equipmentProfile.plant,
        area: this.equipmentProfile.area,
        unit: this.equipmentProfile.unit
      };
      this.$emit("doneUbication", payload);
      this.dialog = false;
    }
  },
  data() {
    return {
      dialog: false,
      e6: 1,
      equipmentProfile: {}
    };
  }
};
</script>
